import dictionary from "../langs.json";

export enum TaskExecutorEnum {
  Kotobot = 0,
  Chipus,
  Logicus,
}

const TaskExecutorImageNames: { [key in TaskExecutorEnum]: string } = {
  [TaskExecutorEnum.Kotobot]: "image1.jpg",
  [TaskExecutorEnum.Chipus]: "image2.jpg",
  [TaskExecutorEnum.Logicus]: "image3.jpg",
};

export function getTaskExecutorImageName(executor: TaskExecutorEnum) {
  return TaskExecutorImageNames[executor];
}

export let isTaskExecutor = (
  variable: unknown
): variable is TaskExecutorEnum => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "number" &&
    variable in TaskExecutorEnum
  );
};

export function getTaskExecutorString(executor: TaskExecutorEnum) {
  return dictionary.ru.translation[
    ("taskExecutor" + executor) as keyof typeof dictionary.ru.translation
  ];
}
